export { menuVariables as menuDividerVariables } from './menuVariables';
